const getCloudinaryUrl = (imgUrl, styles) => {
  if (!imgUrl) return '';

  const imgUrlArray = imgUrl.split('upload/');
  if (imgUrlArray.length < 2) return imgUrl; // fallback if no "upload/"

  return `${imgUrlArray[0]}upload/${styles}/${imgUrlArray[1]}`;
};

export default getCloudinaryUrl;
